import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=fc10f526&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=ts"
export * from "./Manager.vue?vue&type=script&lang=ts"
import style0 from "./Manager.vue?vue&type=style&index=0&id=fc10f526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc10f526",
  null
  
)

export default component.exports